// Recherche d'une entreprise française dans l'annuaire officiel des
// entreprises (recherche-entreprises.api.gouv.fr) : par nom ou par SIREN, les
// entreprises en activité seulement. L'API est publique, sans clé, ouverte aux
// appels du navigateur (CORS *) et limitée à 7 appels par seconde et par
// adresse IP : chaque visiteur l'appelle donc lui-même, sans passer par nous.

const ENDPOINT = "https://recherche-entreprises.api.gouv.fr/search";

// Départements d'outre-mer : l'annuaire donne le département, le formulaire
// attend le pays ISO (ils ont leur propre entrée dans la liste des pays).
const OVERSEAS = {
    971: "GP",
    972: "MQ",
    973: "GF",
    974: "RE",
    976: "YT",
};

const REPETITION = { B: "BIS", T: "TER", Q: "QUATER", C: "QUINQUIES" };

/** Une entreprise de l'annuaire, au format du formulaire de facturation. */
function toCompany(result) {
    const siege = result.siege || {};
    const postalCode = siege.code_postal || "";
    const city = siege.libelle_commune || "";
    let line1 = [
        siege.numero_voie,
        REPETITION[siege.indice_repetition] || siege.indice_repetition,
        siege.type_voie,
        siege.libelle_voie,
    ]
        .filter(Boolean)
        .join(" ");
    // Voie non découpée (lieu-dit) : l'adresse complète, sans code postal ni ville
    if (!line1 && siege.adresse) {
        line1 = siege.adresse.replace(`${postalCode} ${city}`, "").trim();
    }
    return {
        siren: result.siren,
        name: result.nom_raison_sociale || result.nom_complet || "",
        line1,
        line2: siege.complement_adresse || "",
        postalCode,
        city,
        country: OVERSEAS[siege.departement] || "FR",
    };
}

/**
 * Jusqu'à 5 entreprises en activité pour ce nom ou ce SIREN. Lève si
 * l'annuaire ne répond pas (le formulaire propose alors la saisie à la main).
 *
 * @param {string} query au moins 3 caractères
 * @param {{ signal?: AbortSignal }} options
 */
export async function searchCompanies(query, { signal } = {}) {
    const url = new URL(ENDPOINT);
    url.searchParams.set("q", query.trim());
    url.searchParams.set("page", "1");
    url.searchParams.set("per_page", "5");
    url.searchParams.set("minimal", "true");
    url.searchParams.set("include", "siege");
    url.searchParams.set("etat_administratif", "A");
    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error(`annuaire : ${response.status}`);
    const data = await response.json();
    return (data.results || [])
        .filter((result) => result.siren && !result.siege?.code_pays_etranger)
        .map(toCompany);
}
